// extracted by mini-css-extract-plugin
export var button = "_mn-0";